import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addmodifiertype',
  templateUrl: './addmodifiertype.component.html',
  styleUrls: ['./addmodifiertype.component.css']
})
export class AddmodifiertypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  modifiertypeColl: any = [];
  modifiertypeid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  modifiertypeform = new FormGroup({
    modifiertypeid: new FormControl(0),
    modifiertypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Modifiertype";


  @Input() modifiertypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.modifiertypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.modifiertypeform.reset();
      this.fnInitializeModifiertype();

      if (this.modifiertypeid > 0) {
        this.fngetModifiertype();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.modifiertypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeModifiertype() {
    this.modifiertypeform.setValue({

      modifiertypeid: 0,
      modifiertypename: '',
      inactive: false,
    })
  }

  //Get 
  fngetModifiertype() {

    var data = {
      'modifiertypeid': this.modifiertypeid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getModifiertype(data)
      .subscribe(
        (res) => {
          this.modifiertypeColl = res.json().result;
          var editdata = this.modifiertypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.modifiertypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'modifiertypeid': this.modifiertypeid,
          'modifiertypename': this.modifiertypeform.get('modifiertypename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.modifiertypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckModifiertype(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.modifiertypeform.get('modifiertypeid').value > 0) {
                //Update Department
                this.fnSetModifiertype(data);
              }
              else {
                //Insert Department
                this.fnInsertModifiertype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;

                this.modifiertypeform.controls['modifiertypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertModifiertype(data) {

    this.appService.fnInsertModifiertype(data).subscribe(
      (res) => {

        this.saveloading = false;

        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnmodifiertypeid = 0;
          if (result.length > 0) {
            rtnmodifiertypeid = result[0].modifiertypeid
          }
          this.toastr.success('', "The New Modifiertype has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, data.modifiertypeid);

          this.emitData.emit(rtnmodifiertypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  //Set
  fnSetModifiertype(data) {

    this.appService.fnSetModifiertype(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The modifiertype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.modifiertypeid, data.modifiertypename);

          this.emitData.emit(this.modifiertypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.modifiertypeform.setValue({

      modifiertypeid: deptBO.modifiertypeid,
      modifiertypename: deptBO.modifiertypename,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
